import React, { ReactElement } from "react";
import "./card-testimonials.scss";
interface CardInterfacePay {
  children: ReactElement;
  className?: string;
}
const CardTestimonials = (props: CardInterfacePay) => {
  const { children, className } = props;
  return (
    <React.Fragment>
      <div className={`card-testimonials  ${className}`}>
        <div className={`card-methods__wrapper`}>{children}</div>
      </div>
    </React.Fragment>
  );
};

export default CardTestimonials;
